import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Errors } from '../../errors';
import { TextInputComponent } from '../text-input/text-input.component';



/**
 * The OTP Input component presents an input for receiving OTP codes, by default 6 digits long.
 *
 * Please do not pass errors or a type to this control unless you know what you're doing.
 *
 * @example
 * <nom-otp-input [control]="otp"></nom-otp-input>
 */
@Component({
    selector: 'nom-otp-input',
    templateUrl: './otp-input.component.html',
    styleUrls: ['./otp-input.component.scss'],
    standalone: false
})
export class OtpInputComponent extends TextInputComponent implements OnInit {
  @HostBinding('class.nom-otp-input')
  public readonly nomOtpInputClass = true;

  /**
   * The length of the OTP code.
   */
  @Input()
  public codeLength = 6;

  /**
   * @internal
   */
  @HostBinding('style')
  public get style(): object {
    return { '--nom-otp-input-chars': this.codeLength };
  }

  constructor() {
    super();
    this.errors = Errors.otp;
    this.type = 'text';
  }

  ngOnInit() {
    if (!this.placeholder) {
      this.setPlaceholder();
    }
  }

  setPlaceholder() {
    this.placeholder = '0'.repeat(this.codeLength);
  }

  removePlaceholder() {
    this.placeholder = '';
  }
}
